import { render, staticRenderFns } from "./RecoveryPassword.vue?vue&type=template&id=52012169&scoped=true"
import script from "./RecoveryPassword.vue?vue&type=script&lang=js"
export * from "./RecoveryPassword.vue?vue&type=script&lang=js"
import style0 from "./RecoveryPassword.vue?vue&type=style&index=0&id=52012169&prod&lang=scss"
import style1 from "./RecoveryPassword.vue?vue&type=style&index=1&id=52012169&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52012169",
  null
  
)

export default component.exports